const languages = [
  "English",
  "French",
  "Arabic",
  "Mandarin Chinese",
  "Cantonese",
  "Spanish",
  "Portuguese",
  "Punjabi",
  "Hindi",
  "Urdu",
  "Bengali",
  "Tamil",
  "Telugu",
  "Gujarati",
  "Nepali",
  "Sinhala",
  "Tagalog (Filipino)",
  "Vietnamese",
  "Korean",
  "Japanese",
  "Thai",
  "Indonesian",
  "Malay",
  "Burmese",
  "Khmer",
  "Lao",
  "Persian (Farsi)",
  "Turkish",
  "Hebrew",
  "Russian",
  "Ukrainian",
  "Polish",
  "Romanian",
  "German",
  "Dutch",
  "Italian",
  "Greek",
  "Czech",
  "Slovak",
  "Hungarian",
  "Serbian",
  "Croatian",
  "Bosnian",
  "Albanian",
  "Somali",
  "Swahili",
  "Amharic",
  "Tigrinya",
  "Yoruba",
  "Igbo",
  "Hausa",
  "Twi",
  "Afrikaans",
  "Zulu",
  "Xhosa",
  "Other",
];

export default languages;